<div class="loader">
  <div class="loader-inner">
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
  </div>
</div>
